export const QuoteKind = ['none', 'estimated_quote', 'bindable_quote', 'finalized_quote'] as const;
export type QuoteKindType = (typeof QuoteKind)[number];

export const QuoteStatus = [
  'collecting_data',
  'quoted',
  'quoting',
  'errored',
  'estimate_not_available',
  'underwriting_declined',
  'underwriting_pending',
] as const;
export type QuoteStatusType = (typeof QuoteStatus)[number];
